import React from 'react';
import { Link } from 'react-router-dom';

/** Hover target + legal links share one hit area so the panel does not
 *  vanish in the gap between the logo and Privacy / Terms. */
export default function LegalHover({ children, className = '' }) {
  return (
    <div className={`ada-legal-hover ${className}`.trim()}>
      {children}
      <nav className="ada-legal-hover__panel" aria-label="Legal">
        <Link className="ada-legal-hover__link" to="/privacy">
          Privacy
        </Link>
        <span className="ada-legal-hover__dot" aria-hidden="true">
          ·
        </span>
        <Link className="ada-legal-hover__link" to="/terms">
          Terms
        </Link>
      </nav>
    </div>
  );
}
